<template>
    <div class="content" ref="content">
        <div class="box-card" shadow="never" :style="{minHeight: Height}">
            <el-row :gutter="20">
                <el-col :span="4" class="left">1</el-col>
                <el-col :span="16" class="center">
                    <el-tabs v-model="activeName" @tab-click="tabClick">
                        <el-tab-pane label="时间段分析" name="time">
                            <div class="date-btn-box">
                                <el-button-group>
                                    <el-button :class="{'button-active': type == 1}" @click="dateClick(1)">周</el-button>
                                    <el-button :class="{'button-active': type == 2}" @click="dateClick(2)">月</el-button>
                                    <el-button :class="{'button-active': type == 3}" @click="dateClick(3)">全部</el-button>
                                </el-button-group>
                                <el-button v-if="type != 3" type="text" @click="lastDate">{{type == 2 ? '上一月' : '上一周'}}</el-button>
                                <el-button v-if="type != 3" type="text" @click="nextDate">{{type == 2 ? '下一月' : '下一周'}}</el-button>
                            </div>  
                            <el-table
                                class="table"
                                :data="data"
                                border
                                style="width: 100%">
                                <el-table-column 
                                    prop="title" 
                                    label="时间" 
                                    align="center">
                                </el-table-column>
                                <el-table-column 
                                    prop="num" 
                                    label="数量" 
                                    align="center">
                                </el-table-column>
                                <el-table-column 
                                    prop="percentage" 
                                    label="百分比" 
                                    align="center">
                                    <template #default={row}>
                                        {{row.percentage * 100}}%
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center" width="150" >
                                    <template #default={row}>
                                        <el-button type="text" @click="toInfo(row)">详情</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="dateEcharts" ref="dateEcharts"></div>
                        </el-tab-pane>
                        <el-tab-pane label="地域分析" name="region">
                            <el-table
                                class="table"
                                :data="data"
                                border
                                style="width: 100%">
                                <el-table-column 
                                    prop="title" 
                                    label="省份" 
                                    align="center">
                                </el-table-column>
                                <el-table-column 
                                    prop="num" 
                                    label="数量" 
                                    align="center">
                                </el-table-column>
                                <el-table-column  
                                    label="百分比" 
                                    align="center">
                                    <template #default={row}>
                                        {{row.percentage}}%
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center" width="150" >
                                    <template #default={row}>
                                        <el-button type="text" @click="toInfo(row)">详情</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="echarts-box">
                                <div class="mapEcharts" ref="mapEcharts"></div>
                                <div class="regionEcharts" ref="regionEcharts"></div>
                            </div>  
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :span="4" class="right">1
                </el-col>
            </el-row>
        </div>
        <el-dialog
            :visible.sync="dialogVisibleInfo"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="70%">
            <div class="header">
                <div class="search-box"> 
                    <el-date-picker
                        class="date-picker"
                        size="medium"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-model="searchDate"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                    <el-select 
                        v-if="activeName == 'region'"
                         class="search" v-model="searchRegion" size="medium" placeholder="请选择">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option
                        v-for="(item) in data"
                        :key="item.title"
                        :label="item.title"
                        :value="item.title">
                        </el-option>
                    </el-select>
                        
                    <el-button size="medium"  @click="Reset">重置</el-button>
                    <el-button type="primary" size="medium" icon="el-icon-search" @click="search">搜索</el-button>
                </div>
            </div>
            <el-table
                    class="table"
                    :data="tableData"
                    height="500"
                    stripe
                    v-loading="loading"
                    style="width: 100%"
                >
                    
                    <el-table-column
                        align="center"
                        width="200"
                        v-for="(item, index) in tableTitle" :key="index"
                        :prop="item.field"
                        :label="item.title">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        align="center"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button
                                @click.native.prevent="toPreview(scope.row.underwayId)"
                                type="text"
                                size="small">
                                预览
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            <el-pagination
                @current-change="pageChange"
                class="page"
                background
                layout="total, prev, pager, next"
                :total="total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs'
import echarts from 'echarts';
import 'echarts/map/js/china'
export default {
    name: 'AnswerSource',
    data() {
        return{
            Height: '',
            id: '',
            activeName: 'time',
            data: [],
            type: 1,
            weekNow: 0, // 当前周
            monthNow: 0, // 当前月
            monthType: 0, // 月份第二种格式
            dialogVisibleInfo: false,
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            tableTitle: [],
            tableData: [],
            searchDate: '',
            searchRegion: ''
        }
    },
    created() {
        this.id = sessionStorage.getItem("examId")
        this.getDate()
    },
    mounted() {
        this.Height = `${document.documentElement.clientHeight - 100}px`
        
    },
    methods:{
        // 获取上周，本周，下周周一日期
        getDateWeek(n){
            var now = new Date();
            var year = now.getFullYear();
            //因为月份是从0开始的,所以获取这个月的月份数要加1才行
            var month = now.getMonth() + 1;
            var date = now.getDate();
            var day = now.getDay();
            // console.log(date);
            //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
            if (day !== 0) {
                n = n + (day - 1);
            } else {
                n = n + day;
            }
            if (day) {
                //这个判断是为了解决跨年的问题
                if (month > 1) {
                month = month;
                }
                //这个判断是为了解决跨年的问题,月份是从0开始的
                else {
                year = year - 1;
                month = 12;
                }
            }
            now.setDate(now.getDate() - n);
            year = now.getFullYear();
            month = now.getMonth() + 1;
            date = now.getDate();
            // console.log(n);
            var s = year + "-" + (month < 10 ? ('0' + month) : month) + "-" + (date < 10 ? ('0' + date) : date);
            return s;
        },
        // 获取上月，本月，下月周一日期
        getXmonthToday(type, myMonth) {
            // type 0 是当天 -1 是上个月   1是下个月
            var now = myMonth ? new Date(myMonth) : new Date(); // 可以传值调式 now = new Date(2019,2,30); 今天是3月30号
            var year = now.getFullYear();//getYear()+1900=getFullYear()
            var month = now.getMonth() + 1;//0-11表示1-12月
            var day = now.getDate(); // 当天日期
            if (parseInt(month) < 10) {
                month = "0" + month;
            }
            var preMonth = parseInt(month)  - 1;
            preMonth = preMonth < 10 ? '0' + preMonth : preMonth; // 获取上个月的值
            var nextMonth = parseInt(month) + 1;
            nextMonth = nextMonth < 10 ? '0' + nextMonth : nextMonth; // 获取下个月个月的值
            // console.log(parseInt(month) == 1 && type == -1)
            if (parseInt(month) == 1 && type == -1) {//如果是1月份，要上个月 ，则取上一年的12月份
                let data = {
                    format1: (parseInt(year) - 1) + '-12-01',
                    format2: `${(parseInt(year) - 1)},12,1`
                }
                return data
            } else if (parseInt(month) == 12 && type == 1) { // 如果是12月，要下个月，取下一年的1月
                let data = {
                    format1: (parseInt(year) + 1) + '-01-01',
                    format2: `${(parseInt(year) + 1)},1,1`
                }
                return data
            }
            if (type == -1) {
                let data = {
                    format1: year + '-' + preMonth + '-' + '01',
                    format2: `${year},${preMonth},1`
                }
                return data
            } else if (type == 1) {
                let data = {
                    format1: year + '-' + nextMonth + '-' + '01',
                    format2: `${year},${nextMonth},1`
                }
                return data
            }else if(type == 0){
                let data = {
                    format1: year + '-' + month + '-' + '01', // 如果取当月日期可直接 return 返回
                    format2: `${year},${month},1`
                }
                return data
            }
        },
        lastDate() {
            if (this.type == 2) {
                this.monthType = -1
            } else if(this.type == 1) {
                this.weekNow = this.weekNow + 7
            } 
            this.getDate()
        },
        nextDate() {
            if (this.type == 2) {
                this.monthType = 1
            } else if(this.type == 1) {
                this.weekNow = this.weekNow - 7
            } 
            this.getDate()
        },
        dateClick(type) {
            this.type = type
            this.monthType = 0
            this.weekNow = 0
            this.monthNow = 0
            this.getDate()
        },
        Reset() {
            this.searchDate = []
            this.searchRegion = ''
            this.getInfoList()
        },
        search() {
            this.getInfoList()
        },
        getInfoList() {
            // searchDate: '',
            // searchRegion: ''
            this.loading = true
            let that = this
            let data = {
                pageNum: this.pageIndex,
                pageSize: this.pageSize,
                surveyId: this.id,
                startTime: this.searchDate[0] ? this.searchDate[0] : '',
                endTime: this.searchDate[1] ? this.searchDate[1] : '',
            }
            if (this.activeName == 'region') {
                data.searchField = 'province'
                data.searchValue = this.searchRegion == '全部' ? '' : this.searchRegion
            }
            console.log(data)
            let params = {
                that: this,
                url: `${this.$config.service.examGradeCount}`,
                method: "POST",
                data: data,
                cb(res) {
                    // console.log(res)
                    that.loading = false
                    if (res.code == '0'){
                        that.tableTitle = res.resultBody.columns
                        that.tableData = res.resultBody.dataList
                        that.total = res.resultBody.count
                    }
                },
            };
            this.$util.request(params);
        },
        getDate() {
            let that = this
            let beginDate
            if (this.type == 2) {
                let obj = this.getXmonthToday(this.monthType, this.monthNow)
                beginDate = obj.format1
                this.monthNow = obj.format2
            } else if(this.type == 1) {
                beginDate = this.getDateWeek(this.weekNow)
            }
            let data = qs.stringify({
                "type": this.type,
                "surveyId": this.id,
                "startTime": beginDate
            })
            // console.log(data)
            let params = {
                that: this,
                url: `${this.$config.service.examTimeSourceAnalyse}?${data}`,
                method: "POST",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        that.data = res.resultBody
                        let titleArr = [], numArr = []
                        that.data.forEach((info) => {
                            info.percentage = info.percentage.toFixed(2)
                            titleArr.push(info.title)
                            numArr.push(info.percentage)
                        })
                        console.log(that.data)
                        that.$nextTick(()=>{
                            let dateEcharts = echarts.init(that.$refs.dateEcharts)
                            let option = {
                                    tooltip: {
                                        formatter: '{b}：{c}%'
                                    },
                                    xAxis: {
                                        type: 'category',
                                        data: titleArr
                                    },
                                    yAxis: {
                                        type: 'value'
                                    },
                                    series: [
                                        {
                                            data: numArr,
                                            type: 'bar',
                                            color: ['#409EFF'],
                                        }
                                    ]
                            };
                            dateEcharts.clear()
                            dateEcharts.setOption(option)
                        })
                    }
                },
            };
            this.$util.request(params);
            
        },
        getRegion() {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examTerritorySourceAnalyse}?surveyId=${this.id}`,
                method: "POST",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.data = res.resultBody
                        that.data.forEach((info) => {
                            info.percentage = (info.percentage *100).toFixed(2)
                        })
                        let mapEcharts = echarts.init(that.$refs.mapEcharts)
                        let pieArr = [],mapArr = []
                        let region = [
                                '北京',
                                '天津',
                                '上海',
                                '重庆',
                                '河北',
                                '河南',
                                '云南',
                                '辽宁',
                                '黑龙江',
                                '湖南',
                                '安徽',
                                '山东',
                                '新疆',
                                '江苏',
                                '浙江',
                                '江西',
                                '湖北',
                                '广西',
                                '甘肃',
                                '山西',
                                '内蒙古',
                                '陕西',
                                '吉林',
                                '福建',
                                '贵州',
                                '广东',
                                '青海',
                                '西藏',
                                '四川',
                                '宁夏',
                                '海南',
                                '台湾',
                                '香港',
                                '澳门'
                            ]
                        
                        console.log(that.data)
                        that.data.forEach((info) => {
                            pieArr.push({
                                value: info.percentage,
                                name: info.title
                            })
                            region.forEach((item, j)=>{
                                if (info.title == item ) {
                                    mapArr.push({
                                        value: info.num,
                                        name: info.title
                                    })
                                } else {
                                    mapArr.push({
                                        value: 0,
                                        name: item
                                    })
                                }
                            })
                        })
                        
                        // 渲染地图
                        mapEcharts.resize()
                        let mapOption = {
                            tooltip: {  //这里设置提示框
                                trigger: 'item',  //数据项图形触发
                                formatter: '地区：{b}<br/>数量：{c}'
                            },
                            visualMap: {//视觉映射组件
                                show: true,
                                left: 'left',
                                x: 'right',  
                                y: 'bottom', 
                                realtime: false,  //拖拽时，是否实时更新
                                // calculable: true,  //是否显示拖拽用的手柄
                                // inRange: {
                                //     color: ['lightskyblue', 'yellow', 'orangered']
                                // },
                                splitList: [   
                                        {start: 5000, end:500000},{start: 4000, end: 5000},  
                                        {start: 3000, end: 4000},{start: 2000, end: 3000},  
                                        {start: 1000, end: 2000},{start: 1, end: 1000},  
                                    ],  
                                    color: ['#5475f5', '#9feaa5', '#85daef','#74e2ca', '#e6ac53', '#9fb5ea']
                            },
                            legend:{
                                data:[]
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'map',
                                    mapType: 'china',
                                    roam: false,//是否开启鼠标缩放和平移漫游
                                    itemStyle: {//地图区域的多边形 图形样式
                                        normal: {//是图形在默认状态下的样式
                                            label: {
                                                show: true,//是否显示标签
                                                textStyle: {
                                                    color: "black"
                                                }
                                            }
                                        },
                                        zoom: 1.5,  //地图缩放比例,默认为1
                                        emphasis: {//是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
                                            label: { show: true }
                                        }
                                    },
                                    top: "3%",//组件距离容器的距离
                                    data: mapArr,
                                    icon: "circle",   //  设置形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
                                    itemWidth: 10,  // 设置宽度
                                    itemHeight: 10, // 设置高度
                                    itemGap: 20 // 设置间距
                                }
                            ]
                        };
                        mapEcharts.setOption(mapOption)
                        // 渲染环形图
                        let regionEcharts = echarts.init(that.$refs.regionEcharts)
                        let regionOption = {
                                tooltip: {
                                    trigger: 'item',
                                    formatter: `地区：{b}<br/>占比：{c}%`
                                },
                                legend: {
                                    top: '5%',
                                    left: 'center'
                                },
                                series: [
                                    {
                                        data: pieArr,
                                        type: 'pie',
                                        radius: ['40%', '70%'],
                                        color: ['#37A2DA',
                                        '#32C5E9',
                                        '#67E0E3',
                                        '#9FE6B8',
                                        '#FFDB5C',
                                        '#ff9f7f',
                                        '#fb7293',
                                        '#E062AE',
                                        '#E690D1',
                                        '#e7bcf3',
                                        '#9d96f5',
                                        '#8378EA',
                                        '#96BFFF'],
                                        avoidLabelOverlap: false,
                                        label: {
                                            show: false,
                                            position: 'center'
                                        },
                                        emphasis: {
                                            label: {
                                            show: true,
                                            fontSize: '40',
                                            fontWeight: 'bold'
                                            }
                                        },
                                        labelLine: {
                                            show: false
                                        },
                                    }
                                ]
                        };
                        regionEcharts.clear()
                        regionEcharts.setOption(regionOption)
                    }
                },
            };
            this.$util.request(params);
            
        },
        toPreview(id) {
            this.$router.push({
                name: 'UserExamPreview',
                params: {
                    id: this.id,
                    userId: id,
                    findResultParse: 1,
                    showGradeBill: 1
                }
            })
        },
        toInfo(item, index) {
            this.pageIndex = 1
            this.startTime = ''
            this.endTime = ''
            this.searchRegion = ''
            this.getInfoList()
            this.dialogVisibleInfo = true
        },
        tabClick() {
            if(this.activeName == 'time'){
                this.monthNow = 0
                this.monthType = 0
                this.getDate()
            } else {
                this.getRegion()
            }
        },
        pageChange(e) {
            this.pageIndex = e
            this.getInfoList()
        },
        viewAnswerSheet(id) {
            // this.$router.push('/') 预览页
        }
    }
}
</script>

<style scoped lang="scss">
.content{
    margin:20px 20px 20px 100px;
    .box-card{
        padding: 20px 10%;
        background-color: #fff;
        border: 1px solid #EBEEF5;
        .left,.right{
            opacity: 0;
        }
        .center{
            .date-btn-box{
                display: flex;
                align-items: center;
            }
            /deep/.el-button-group{
                margin-right: 10px;
            }
            .button-active{    
                color: #409EFF;
                border-color: #c6e2ff;
                background-color: #ecf5ff;
            }
            .table{
                margin-top: 30px;            
            }
            .dateEcharts{
                height: 300px;
            }
            .echarts-box{
                display: flex;
                margin-top: 50px;
                .mapEcharts{
                    height: 400px;
                    width: 70%;
                }
                .regionEcharts{
                    
                    height: 400px;
                    width: 30%;
                }
            }


        }
    }
}
/deep/.el-tabs__nav{
    width: 100%;
}
/deep/.el-tabs__item{
    text-align: center;
    width: 50%;
    font-size: 16px;
    height: 52px;
    font-weight: bold;
}
/deep/.el-table__cell .el-button{
    padding: 0;
}
.header{
        display: flex;
        justify-content: space-between;
        .search-box{
                display: flex;
            .search,.date-picker{
                margin-right: 10px;
            }
        }
        .popover{
            margin:0 10px;
        }
    }
.page{
    margin-top: 20px;
    text-align: right;
}
.table{
    margin-top: 30px;
}
/deep/.el-button--medium{
    padding: 10px 20px;
}
</style>